import { RowEditModal } from 'pages/admin/demand/averageTicket/components/RowEdit';

export const columnsDataPrecoMedio = [
	{
		Header: 'Produto',
		accessor: 'produto',
		type: 'text',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cód. Produto',
		accessor: 'codProduto',
		type: 'text',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Canal de Venda',
		accessor: 'canalVenda',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Família',
		accessor: 'familia',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Recalcular',
		accessor: 'recalcular',
		type: 'toggleAndEditModal',
		filter: false,
		helper: true,
		optional: true,
		isModal: true,
	},
	{
		Header: 'Preço Médio',
		accessor: 'ticketMedio',
		type: 'money',
		isDisabled: false,
		filter: 'includesIgnoreCase',
		onlyEdit: true,
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: RowEditModal,
		filter: false,
	},
];
